module.exports = __webpack_public_path__ + "img/price.1513854.png";